
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MbscModule } from '@mobiscroll/angular';
import { categoryData, operatingTimeData, statusData, taskType } from '../../../../interfaces/selectData';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { FormsModule } from '@angular/forms';
import { getPopupButtonsTemplateFilter, popupOptions, sliderOptions } from '../../../../interfaces/popup-buttons/filter/popup-options';
import { FetchUserService } from '../../../../services/fetchServices/fetchUser/fetch-user.service';
import { TemplateFilterService } from '../../../../services/shared/filter/template-filter.service';
import { GetOptionsService } from '../../../../services/fetchServices/fetchOptions/GET/get-options.service';

@Component({
  selector: 'app-filter-template-popup',
  imports: [MbscModule, FormsModule, NgxSliderModule],
  templateUrl: './filter-template-popup.component.html',
  styleUrl: './filter-template-popup.component.scss'
})
export class FilterTemplatePopupComponent implements OnInit{
  @ViewChild('templateFilterButton', { static: false }) templateFilterButton!: ElementRef;
  @ViewChild('templateFilterPopup', { static: false }) templateFilterPopup: any;

  @Input() templates: any[] = [];
  @Output() onFilteredTemplateChange = new EventEmitter<any[]>();

  popupAnchorTemplateFilter: HTMLElement | null = null;
  onlyMyTemplates: boolean = false;

  searchTitle: string = '';
  searchLocation: string = '';
  searchCustomer: string = '';
  searchStatus: any;
  searchCategory: any;
  searchOperatingTime: any;
  searchTaskType: any;
  searchOnline: any;
  searchStartTime: any;
  searchEndTime: any;
  searchAuthor: any;

  statusData = statusData;
  categoryData = categoryData;
  operatingTimeData = operatingTimeData;
  taskType = taskType;

  minDuration: number = 1;
  maxDuration: number = 15;

  filter: any;
  filteredTemplates: any[] | null = null;
  selectedIds: (string | number)[] = [];
  user: any;

  public popupOptions = popupOptions;
  public sliderOptions = sliderOptions;
  popupButtonsTemplateFilter = getPopupButtonsTemplateFilter(() => this.resetFilter());

  private isRestoring = false;
  private debounceTimer: any;

  constructor(
    private templateFilterService: TemplateFilterService,
    private fetchUserService: FetchUserService,
    private getOptionsService: GetOptionsService,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    const options: any = await this.getOptionsService.fetchOptions();

    if (options && options.user) {
      this.user = options.user.map((u: any) => ({
        value: u.id,
        text: `${u.firstName} ${u.lastName}`,
        email: u.email,
        firstname: u.firstName,
        lastname: u.lastName,
        kuerzel: u.kuerzel,
        role: u.role,
        userGroups: u.usergroup
      }));

      // console.log('Fetched user options:', this.user);
      this.cdr.detectChanges();
    }
    this.restoreFilter();
  }

  restoreFilter() {
  const storage = localStorage.getItem('templateFilter');
  if (!storage) return;

  try {
    this.isRestoring = true;
    const savedFilter = JSON.parse(storage);

    this.onlyMyTemplates = !!(savedFilter.authorIds?.length === 1 && this.isCurrentUser(savedFilter.authorIds[0]));
    this.selectedIds = savedFilter.authorIds || [];

    this.searchTitle = savedFilter.searchTitle || '';
    this.searchLocation = savedFilter.searchLocation || '';
    this.searchStatus = savedFilter.searchStatus || [];
    this.searchCategory = savedFilter.searchCategory || [];
    this.searchOperatingTime = savedFilter.searchOperatingTime || [];
    this.searchTaskType = savedFilter.searchTaskType || [];
    this.searchOnline = savedFilter.searchOnline;
    this.searchStartTime = savedFilter.searchStartTime ? new Date(savedFilter.searchStartTime) : undefined;
    this.searchEndTime = savedFilter.searchEndTime ? new Date(savedFilter.searchEndTime) : undefined;
    this.minDuration = savedFilter.minDuration ?? 1;
    this.maxDuration = savedFilter.maxDuration ?? 15;

    this.applyTemplateFilter(false);
  } finally {
    setTimeout(() => (this.isRestoring = false), 100);
  }
}

private isCurrentUser(id: number): boolean {
  const storedUser = localStorage.getItem('authUser');
  const currentUserId = storedUser ? JSON.parse(storedUser).user?.id : undefined;
  return id === currentUserId;
}


  applyTemplateFilter(saveToStorage = true) {
  if (this.isRestoring) return;

  clearTimeout(this.debounceTimer);
  this.debounceTimer = setTimeout(() => {
    const storedUser = localStorage.getItem('authUser');
    const currentUserId = storedUser ? JSON.parse(storedUser).user?.id : undefined;

    // 👇 Autoren bestimmen: eigene ID oder ausgewählte Benutzer
    let authorIds: number[] | undefined;
    if (this.onlyMyTemplates) {
      authorIds = [currentUserId];
    } else if (this.selectedIds && this.selectedIds.length > 0) {
      authorIds = this.selectedIds.map(id => Number(id));
    }

    this.filter = {
      authorIds, // 👈 neues Feld
      searchTitle: this.searchTitle,
      searchLocation: this.searchLocation,
      searchStatus: this.searchStatus || [],
      searchCategory: this.searchCategory || [],
      searchOperatingTime: this.searchOperatingTime || [],
      searchTaskType: this.searchTaskType || [],
      searchOnline: this.searchOnline,
      searchStartTime: this.searchStartTime,
      searchEndTime: this.searchEndTime,
      minDuration: this.minDuration,
      maxDuration: this.maxDuration
    };

    if (saveToStorage) {
      localStorage.setItem('templateFilter', JSON.stringify(this.filter));
    }

    this.filteredTemplates = this.templateFilterService.filterTemplate(
      this.templates,
      this.filter
    );

    this.onFilteredTemplateChange.emit(this.filteredTemplates);
  }, 400);
}


  resetFilter() {
    this.selectedIds = [];
    this.searchAuthor = 0;
    this.searchTitle = '';
    this.searchLocation = '';
    this.searchStatus = [];
    this.searchCategory = [];
    this.searchOperatingTime = [];
    this.searchTaskType = [];
    this.searchOnline = undefined;
    this.searchStartTime = undefined;
    this.searchEndTime = undefined;
    this.minDuration = 1;
    this.maxDuration = 15;
    this.onlyMyTemplates = false;

    localStorage.removeItem('templateFilter');

    this.filteredTemplates = [...this.templates];
    this.onFilteredTemplateChange.emit(this.filteredTemplates);
  }

  openTemplateFilter(popupAnchor: any) {
    this.popupAnchorTemplateFilter = popupAnchor;
    this.templateFilterPopup.open();
  }

  setFilterOptions() {
    const storage = localStorage.getItem('templateFilter');
    // console.log('storage: ', JSON.parse(storage || '{}'));
  }
}